import type {
    LaunchCommerceCustomerActionRequest,
    LaunchCommerceCustomerActionResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const launchCommerceCustomerActionOperation = defineCommerceOperation<
    LaunchCommerceCustomerActionRequest,
    LaunchCommerceCustomerActionResponse
>("commerce.customer.actions.launch");
